import {
  getUserConfig,
  IUpdateConfigParams,
  updateUserConfig,
} from '@/services/user';
import { useState } from 'react';

// TODO: 将config放到一个全局地方
const useUserConfig = () => {
  const [config, setConfig] = useState<Record<string, string>>({});

  const getConfig = async (keys: string[]) => {
    const data = await getUserConfig(keys);
    setConfig((prev) => ({
      ...prev,
      ...data,
    }));
    return data;
  };

  const updateConfig = async (data: IUpdateConfigParams) => {
    await updateUserConfig(data);
    setConfig((prev) => ({
      ...prev,
      [data.key]: data.value,
    }));
  };

  return {
    userConfig: config,
    getUserConfig: getConfig,
    updateUserConfig: updateConfig,
  };
};

export default useUserConfig;
